// ============================================
// 📥 IMPORTAÇÃO DE VENDAS (CSV) — portado do n8n
// ============================================
// Mesma regra do nó "Processar CSV - Limpa Hora" do fluxo
// "UPLOAD MULTI-FORMATO - LIMPA HORA DA DATA", que saiu do n8n em 2026-09-26.
// Formato de cada linha: Data,Telefone,Nome (vírgula ou TAB), com cabeçalho.
// ============================================

const dataValida = (ano, mes, dia) => {
  const anoNum = parseInt(ano, 10);
  const mesNum = parseInt(mes, 10);
  const diaNum = parseInt(dia, 10);
  if (mesNum < 1 || mesNum > 12) return false;
  if (diaNum < 1 || diaNum > 31) return false;
  return anoNum >= 2000 && anoNum <= 2100;
};

const montarData = (ano, mes, dia) => {
  const anoCompleto = ano.length === 2 ? `20${ano}` : ano;
  const mm = mes.padStart(2, '0');
  const dd = dia.padStart(2, '0');
  return dataValida(anoCompleto, mm, dd) ? `${anoCompleto}-${mm}-${dd}` : '';
};

// Segundo número > 12 → americano (M/D/YY); primeiro > 12 → brasileiro (D/M/YY);
// ambos ≤ 12 → americano, que é o padrão do Excel ao exportar CSV.
const dataComBarras = (texto) => {
  const partes = texto.split('/').map(p => p.trim());
  if (partes.length !== 3) return '';
  const [p1, p2, ano] = partes;
  const brasileiro = parseInt(p2, 10) <= 12 && parseInt(p1, 10) > 12;
  return brasileiro ? montarData(ano, p2, p1) : montarData(ano, p1, p2);
};

const dataComHifen = (texto) => {
  const partes = texto.split('-').map(p => p.trim());
  if (partes.length !== 3) return '';
  const [ano, mes, dia] = partes;
  const mm = mes.padStart(2, '0');
  const dd = dia.padStart(2, '0');
  return dataValida(ano, mm, dd) ? `${ano}-${mm}-${dd}` : '';
};

/** Converte a data da planilha para YYYY-MM-DD, descartando a hora. '' se inválida. */
export const limparData = (valor) => {
  if (!valor) return '';
  const texto = String(valor).trim().split(' ')[0].split('T')[0];
  if (texto.includes('/')) return dataComBarras(texto);
  if (texto.includes('-')) return dataComHifen(texto);
  return '';
};

const lerLinha = (linha) => {
  const colunas = linha.split(linha.includes('\t') ? '\t' : ',');
  if (colunas.length < 3) return null;
  const dataCompra = limparData(colunas[0]?.trim());
  const telefoneBruto = colunas[1]?.trim() || '';
  const nome = colunas[2]?.trim() || '';
  if (!dataCompra || !telefoneBruto || !nome) return null;
  const telefone = telefoneBruto.replace(/[^0-9]/g, '');
  if (telefone.length < 8) return null;
  return { telefone, nome, data_compra: dataCompra };
};

/** Lê o CSV inteiro. Devolve as vendas válidas e quantas linhas foram descartadas. */
export const processarCsvVendas = (csvTexto) => {
  if (!csvTexto || typeof csvTexto !== 'string') return { registros: [], erros: 0 };
  const linhas = csvTexto.trim().split('\n').filter(l => l.trim()).slice(1);
  const registros = [];
  let erros = 0;
  linhas.forEach((linha) => {
    const registro = lerLinha(linha.replace(/\r$/, ''));
    if (registro) registros.push(registro);
    else erros += 1;
  });
  return { registros, erros };
};
